import React from 'react';

export const SidePanelRow = ({ className = '', children, title, text }) => {
  return (
    <div className={'row ' + className}>
      {!!title && (
        <div className={'order-divider'}>
          <div className={'section-name'}>{title}</div>
          <div className={'line'} />
        </div>
      )}
      {!!text && <div className={'order-text'}>{text}</div>}
      {children}
    </div>
  );
};
